module.exports = __webpack_public_path__ + "img/founders_04.0d5c7662.jpg";